// extracted by mini-css-extract-plugin
export var link = "_rn-0";